import { z } from 'zod';
import { IdPrefix, ID_LEN } from './prefixes.js';
/**
 * Per-entity Zod ID schemas for use at API boundaries.
 *
 * Each schema validates:
 * - Type is string
 * - String starts with the correct entity prefix
 * - Total length is exactly 19 (3-char prefix + 16-char body)
 *
 * Use these in MCP tool input schemas, REST handler input schemas, and
 * anywhere a Deckspace-owned ID crosses an API boundary. Replaces ad-hoc
 * z.string() or z.uuid() validation.
 */
const makeIdSchema = (prefix) => z
    .string()
    .startsWith(prefix, `Expected ${prefix}-prefixed ID`)
    .length(ID_LEN, `Expected ID of length ${ID_LEN}`);
export const workspaceIdSchema = makeIdSchema(IdPrefix.Workspace);
export const workspaceMemberIdSchema = makeIdSchema(IdPrefix.WorkspaceMember);
export const pageIdSchema = makeIdSchema(IdPrefix.Page);
export const datasetIdSchema = makeIdSchema(IdPrefix.Dataset);
export const rowIdSchema = makeIdSchema(IdPrefix.Row);
export const surfaceIdSchema = makeIdSchema(IdPrefix.Surface);
export const changeIdSchema = makeIdSchema(IdPrefix.Change);
export const userPreferenceIdSchema = makeIdSchema(IdPrefix.UserPreference);
//# sourceMappingURL=schemas.js.map